import styled from 'styled-components';
import { COLOR } from '@src/styles/color';
import { PLAYHEAD_LINE_Z } from '@src/constants/timeline';

// Zero-width anchor carrying the time-driven position, rendered INSIDE the
// scrollable content so it scrolls + clips natively with the clips/ruler.
export const StyledPlayheadLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  width: 0;
  z-index: ${PLAYHEAD_LINE_Z};
  pointer-events: none;
  will-change: transform;
`;

// The visible 1px line, exactly on the time position.
export const StyledLine = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  border-left: 1px solid ${COLOR.darkBlue};
`;

// Widened, transparent hit area centred on the line so the 1px line is easy to
// grab anywhere down its height (it overlays the tracks, so only this thin strip
// captures them).
export const StyledGrab = styled.div`
  position: absolute;
  top: 0;
  bottom: 0;
  left: -6px;
  width: 12px;
  pointer-events: auto;
  cursor: ew-resize;
  touch-action: none;
  user-select: none;
`;
